import { nextApiRequest } from '@/utils/request';
import { SettledValidCode, SettledResponseData } from '@/interface/settled';

export async function postSettled(data) {
  return nextApiRequest.request<SettledResponseData>({
    method: 'post',
    url: '/v1/boxcompany',
    data,
  });
}

export async function postSendValidCode(data) {
  return nextApiRequest.request<SettledValidCode>({
    method: 'post',
    url: '/v1/boxcompany/valid_code',
    data,
  });
}
